<script>
    import {createEventDispatcher} from "svelte";
    import {currentLanguage} from "../../stores/store";

    export let languages = [];
    export let column = false;
    export let active = 0;

    const unsubscribe = currentLanguage.subscribe(value => {
        active = value;
    });
</script>

<style>

    .btn {
        background-color: #f0f0f0;
    }

 .active {
     color: white;
     background-color: blue;
 }
 .active:hover {
     color: white;
 }



 p{
     font-weight: bold;
     color: black;
     transition: all 0.5s;
     padding: 2px 10px 2px 10px;
     margin: 0;
 }

</style>

<div class="wrapper d-flex {column ? 'flex-column' : ''}">
        {#each languages as lang,i}
                <a class="btn shadow-drop-bl-hover {active === i ? 'active' : ''}" href="/{lang.lang}">{lang.text}</a>
        {/each}
</div>